import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Azul corporativo Ibercar como color primario del panel (tema claro denso).
// Los tokens compartidos con rider (@ibercar/rider-ui) son hoy del tema OSCURO
// guest; cuando rider-ui exponga primitivos neutros se reutilizarán aquí (F2+).
const ibercarBlue: MantineColorsTuple = [
  '#e7f1ff',
  '#cfe0ff',
  '#9cbdff',
  '#6699ff',
  '#3b7afe',
  '#2167fe',
  '#0f5dff',
  '#004ee4',
  '#0045cd',
  '#003ab5',
];

export const theme = createTheme({
  primaryColor: 'ibercar',
  colors: { ibercar: ibercarBlue },
  defaultRadius: 'md',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
});
